// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomedTableFooter_root__39R2Z","search":"CustomedTableFooter_search__1ocyg","pagination":"CustomedTableFooter_pagination__j5Ew_"};